module.exports = __webpack_public_path__ + "static/media/rentRates2Bedroom-CondoApt-01.f596cd98.png";